import React, { useRef } from 'react'
import { MapContainer,Marker,Popup,TileLayer } from 'react-leaflet'
import l from 'leaflet'
import 'leaflet/dist/leaflet.css'
const FplazaMap = () => {
    const ref=useRef()
    const maker=new l.icon({
        iconUrl:'https://unpkg.com/leaflet@1.6.0/dist/images/marker-icon-2x.png',
        iconSize:[25,35],
        popupAnchor:[-3,7],
       iconAnchor:[14,-7]
    })
  return (
    <div>
       <MapContainer center={[6.6727413,-1.5630001]} zoom={13} ref={ref}>
        <TileLayer url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' />
        <Marker position={[6.6779479,-1.5471778]} icon={maker}>
            <Popup>
                <h3>F Plaza</h3>
            </Popup>
        </Marker>
      </MapContainer>
    </div>
  )
}

export default FplazaMap